import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { FileText, ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";

// Mock modda yüklenen belgelerin gerçek içeriği yok — bir dosya kutucuğuna
// tıklandığında "içerik var" hissi veren, sabit Lorem Ipsum ile doldurulmuş bir
// sayfa önizlemesi gösterir. `fileUrl` verildiğinde (canlı modda, gerçek backend'in
// /public/files/project_files/{storedFileName} yolundan servis ettiği dosya —
// bkz. projectService.getProjectFileUrl) bunun yerine gerçek dosya gösterilir.
// Resimler <img> ile gömülü açılır; diğer tipler (PDF vb.) <iframe> İLE AÇILAMAZ —
// backend bu yolu `X-Frame-Options: DENY` ile servis ediyor (canlı doğrulandı,
// SAMEORIGIN bile değil), o yüzden onlar için sadece "Yeni Sekmede Aç" bağlantısı
// gösterilir; tam sayfa navigasyonu bu başlıktan etkilenmez.
const LOREM_PARAGRAPHS = [
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
  "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.",
];

function isImageFile(name) {
  return /\.(jpe?g|png|gif|webp)$/i.test(name || "");
}

export default function DocumentPreviewModal({ isOpen, toggle, fileName, fileUrl }) {
  const { t } = useTranslation("components");
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size={fileUrl && isImageFile(fileName) ? "lg" : undefined}>
      <ModalHeader toggle={toggle}>
        <span className="text-truncate d-inline-block align-middle" style={{ maxWidth: 380 }}>
          {fileName || t("belgeOnizleme.belgeOnizleme")}
        </span>
      </ModalHeader>
      <ModalBody className="bg-light">
        {fileUrl ? (
          isImageFile(fileName) ? (
            <img src={fileUrl} alt={fileName} className="w-100" style={{ maxHeight: 600, objectFit: "contain" }} />
          ) : (
            <div className="d-flex flex-column align-items-center justify-content-center text-center py-5">
              <FileText size={48} className="text-muted mb-3" />
              <div className="fw-semibold mb-1">{fileName}</div>
              <div className="text-muted small mb-3">{t("belgeOnizleme.buDosyaTipiBuradaGomulu")}</div>
            </div>
          )
        ) : (
          <div
            className="bg-white shadow-sm mx-auto p-4"
            style={{ maxWidth: 420, minHeight: 520, border: "1px solid var(--vz-border-color)" }}
          >
            <div className="d-flex align-items-center gap-2 pb-3 mb-3 border-bottom">
              <FileText size={18} className="text-muted flex-shrink-0" />
              <div className="text-truncate fw-semibold small">{fileName || "belge.pdf"}</div>
            </div>
            {LOREM_PARAGRAPHS.map((p, i) => (
              <p key={i} className="text-muted small" style={{ lineHeight: 1.7 }}>{p}</p>
            ))}
          </div>
        )}
      </ModalBody>
      {fileUrl && (
        <ModalFooter>
          <Button color="primary" outline tag="a" href={fileUrl} target="_blank" rel="noreferrer">
            <ExternalLink size={14} className="me-1" />{" "}{t("belgeOnizleme.yeniSekmedeAcYazdir")}
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
}
